import { create } from 'domain'
import { Age } from 'types/age'
import { Education } from 'types/education'
import { Gender } from 'types/gender'
import { Publication } from 'types/publication'
import { createStandardAction } from 'typesafe-actions'

export const updateAge = createStandardAction('demographics/set/age')<Age>()
export const updateGender = createStandardAction('demographics/set/gender')<
  Gender
>()
export const updateEducation = createStandardAction(
  'demographics/set/education'
)<Education>()
export const updatePublication = createStandardAction(
  'demographics/set/publication'
)<Publication>()
